<template>
  <div class="integral" v-if="show">
    <div class="intCenter">
      <img src="../../../assets/images/nonet.png">
      <p>啊哦，网络不太顺畅哦～</p>
      <button class="redbtn" @click="Reload">重新加载</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'noNet',
  data () {
    return {
      show: false
    }
  },
  methods: {
    close: function () {
      this.show = false
    },
    Reload () {
      this.reload()
      this.close()
    }
  }
}
</script>

<style scoped lang="less">
.integral {
  min-height: 100%;
  background: #fff;
  position: relative;
  z-index: 11;
  .intCenter {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    img {
      width: 1.12rem;
      height: 1.12rem;
      margin: 0 auto;
    }
    p{
      font-size:0.13rem;
      font-weight:400;
      color:rgba(41,41,41,1);
      line-height:0.18rem;
      margin-top: 0.23rem;
      margin-bottom: 0.96rem;
    }
    .redbtn {
      outline: none;
      margin: 0 auto;
      display: block;
      background: none;
      min-width:1.09rem;
      border-radius:0.2rem;
      padding: 0.08rem 0;
      border:1px solid rgba(252,3,36,1);
      font-size:0.14rem;
      font-weight:400;
      color:rgba(252,3,36,1);
      line-height:0.2rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emptypage/noNet/noNet.vue